import useMediaQuery from '@mui/material/useMediaQuery';
import styles from 'styles/mediaQueries.scss';

export default () => useMediaQuery(`(max-width:${styles.mediaQueryMobile}px)`);
